import { EssHeader } from '@/components/ess/EssHeader';
import { FC } from 'react';
import { FiCalendar } from 'react-icons/fi';
import { NavPage } from '../../../../components/page/Breadcrumbs';
import strings from '../../ess.translations';

export const MyLeaveHeader: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.myLeave.header,
      to: `/ess/my-calendar/my-leave`
    }
  ];

  return <EssHeader title={strings.myLeave.header} icon={FiCalendar} breadcrumbs={breadcrumbs} />;
};
